import Directus from "./Directus";

const DirectusVue = {
    install(Vue, options) {
        Vue.$directus = new Directus(options.endpoint, options.collections)
        Vue.prototype.$directus = Vue.$directus
    }
}
export default DirectusVue